import { NavigationType, Router } from "react-router-dom";
import { useRef, useState, useLayoutEffect } from "react";
import { createBrowserHistory, History } from "history";

//! NOTE: Don't export customHistory! Use RouterStore instead!!
const customHistory = createBrowserHistory();

export function CustomBrowserRouter({ basename, children }) {
  const historyRef = useRef<History>();
  if (historyRef.current == null) {
    historyRef.current = customHistory;
  }
  const history = historyRef.current;
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      children={children}
      location={state.location}
      navigationType={state.action as NavigationType}
      navigator={history}
    />
  );
}

export class RouterStore {
  private static prepareUrl(url: string) {
    return url.startsWith("/") ? url.slice(1) : url;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static push(url: string, state?: any) {
    customHistory.push(`/${window.GLOBAL.ROUTER_BASE}/${this.prepareUrl(url)}`, state);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static replace(url: string, state?: any) {
    customHistory.replace(`/${window.GLOBAL.ROUTER_BASE}/${this.prepareUrl(url)}`, state);
  }

  public static get location() {
    return customHistory.location;
  }
}
